import type { Hero, Level, Quest } from "./types";
import { CAST } from "./levels";

/** The heroes on the bench for a level: the first `heroCount` of the cast. */
export function heroesFor(level: Level): Hero[] {
  return CAST.slice(0, level.heroCount);
}

/** Gold a hero earns on a contract: the flat purse plus gold per stat point. */
export function payoff(hero: Hero, quest: Quest): number {
  return (
    quest.base +
    quest.weights[0] * hero.stats[0] +
    quest.weights[1] * hero.stats[1] +
    quest.weights[2] * hero.stats[2]
  );
}

/** The level's full payoff matrix: rows = heroes, columns = quests. */
export function payoffMatrix(level: Level): number[][] {
  return heroesFor(level).map((h) => level.quests.map((q) => payoff(h, q)));
}
